import React from "react";
import PdfSign from "../../Images/pdf-sign.svg";
import vahanIcon from "../../Images/Svg/vahanIcon.svg";
import cardVerificationIcon from "../../Images/Svg/cardVerificationIcon.svg";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Vahan from "./Vahan";
import Challan from "./Challan";
import PanVerification from "./PanVerification";
import DLVerification from "./DLVerification";
import Aadhaar from "./Aadhaar";
import { images } from "../../Images/Svg";
import { useSelector } from "react-redux";
import { Avatar, Skeleton } from "@mui/material";

const { VerifiedIcon } = images;
const topographyStyles = {
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: 600,
  color: "#242424",
  ml: "12px",
};
const boxStyles = {
  display: "flex",
  alignItems: "center",
};
const iconStyles = {
  width: "18px",
  height: "18px",
  fontWeight: "600",
  color: "#3A3A3A",
  margin: "0 2rem",
};
const commonStyles = {
  padding: "0 2.5rem",
  ".MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded": {
    minHeight: "unset",
  },
  ".MuiPaper-root.MuiAccordion-rounded::before": {
    opacity: 1,
  },
  ".MuiPaper-root.MuiAccordion-rounded.Mui-expanded::before": {
    opacity: 1,
  },
  ".MuiAccordion-root": {
    boxShadow: "none",
  },
  ".MuiAccordionSummary-root": {
    marginBottom: "2rem",
    padding: "0.8rem",
  },
  ".MuiAccordion-root.Mui-expanded": {
    margin: "unset",
  },
  ".MuiAccordionSummary-content": {
    margin: "unset",
  },
  ".MuiAccordionSummary-content.Mui-expanded": {
    margin: "unset",
  },
};

const ExternalInformation = ({
  data,
  documentDetails,
  onClickDocument = () => {},
  boxShadow,
  backgroundColor,
}) => {
  const lobName = useSelector((state) => state?.CaseDescriptionSlice?.lobName);
  return (
    <Paper
      sx={{
        ...commonStyles,
        boxShadow,
        backgroundColor,
      }}
      elevation={4}
    >
      {data?.panInfo &&
        !Object?.keys(data?.panInfo)?.length &&
        Array(lobName?.toLowerCase() === "motor" ? 4 : 1)
          ?.fill("loading")
          ?.map((item, index) => (
            <Box
              key={item + index}
              sx={{
                display: "flex",
                padding: "0.8rem 0 2.8rem 0",
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              }}
            >
              <Skeleton animation="wave" variant="circular">
                <Avatar />
              </Skeleton>
              <Skeleton animation="wave" width="20%" sx={{ ml: "12px" }} />
            </Box>
          ))}

      {(data?.lobName?.toLowerCase() === "motor" ||
        data?.lob_name?.toLowerCase() === "motor") && (
        <>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={iconStyles} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Box sx={boxStyles}>
                <img src={vahanIcon} alt="cntrl+svg" />
                <Typography sx={topographyStyles}>Vahan</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <Vahan content={data?.vehicleInfo} />
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={iconStyles} />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Box sx={boxStyles}>
                <img src={vahanIcon} alt="cntrl+svg" />
                <Typography sx={topographyStyles}>Challan</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <Challan content={data?.challanInfo} />
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={iconStyles} />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Box sx={boxStyles}>
                <img src={cardVerificationIcon} alt="cntrl+svg" />
                <Typography sx={topographyStyles}>DL Verification</Typography>
                <span
                  style={{
                    marginLeft: "1rem",
                    display: data?.dlInfo?.is_dl_verified
                      ? "inline-block"
                      : "none",
                  }}
                >
                  <img
                    src={VerifiedIcon}
                    alt="verifiedIcon"
                    style={{ display: "flex" }}
                  />
                </span>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <DLVerification content={data?.dlInfo} />
              </Typography>
            </AccordionDetails>
          </Accordion>
        </>
      )}
      {(data?.lobName?.toLowerCase() === "motor" ||
        data?.lobName?.toLowerCase() === "health" ||
        data?.lob_name?.toLowerCase() === "motor" ||
        data?.lob_name?.toLowerCase() === "health") && (
        <>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={iconStyles} />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Box sx={boxStyles}>
                <img src={cardVerificationIcon} alt="cntrl+svg" />
                <Typography sx={topographyStyles}>Pan Verification</Typography>
                <span
                  style={{
                    marginLeft: "1rem",
                    display: data?.panInfo?.is_pan_verified
                      ? "inline-block"
                      : "none",
                  }}
                >
                  <img
                    src={VerifiedIcon}
                    alt="verifiedIcon"
                    style={{ display: "flex" }}
                  />
                </span>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <PanVerification content={data?.panInfo} />
              </Typography>
            </AccordionDetails>
          </Accordion>
          {/* <Accordion>
                        <AccordionSummary
                            expandIcon={
                                <ExpandMoreIcon sx={iconStyles} />
                            }
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Box sx={boxStyles}>
                                <img src={cardVerificationIcon} alt="cntrl+svg" />
                                <Typography sx={topographyStyles}>
                                    Aadhaar
                                </Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                <Aadhaar />
                            </Typography>
                        </AccordionDetails>
                    </Accordion> */}
        </>
      )}
      {/* <Accordion>
                <Grid
                    container
                    spacing={1}
                    sx={{ paddingLeft: 1 }}
                >
                    <Grid item xs={6}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: "13px",
                                color: "#242424",
                                wordWrap: "break-word",
                            }}
                        >
                            Documents
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ display: "flex", flexWrap: "wrap" }}>
                        {documentDetails.map((item) => (
                            <Grid
                                container
                                lg={2}
                                md={3}
                                sm={4}
                                xs={12}
                                sx={{
                                    width: "17rem",
                                    height: "4.2rem",
                                    background: "#FAFAFA",
                                    border: "1px solid #E8E8E8",
                                    borderRadius: "4px",
                                    marginRight: "4rem",
                                    marginBottom: "2rem",
                                }}
                                key={item?.name}
                            >
                                <Grid item xs={2.5} sx={{ padding: "1rem" }}>
                                    <img
                                        src={PdfSign}
                                        alt="pdf-sign"
                                        onClick={(e, PdfSign) => onClickDocument(e, PdfSign)}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={9.5}
                                    sx={{ paddingTop: "0.8rem", paddingLeft: "0.5rem" }}
                                >
                                    <Typography
                                        sx={{ fontSize: "1.2rem", lineHeight: "1.5rem" }}
                                    >
                                        {item.name}
                                    </Typography>
                                    <Typography sx={{ fontSize: "0.8rem" }}>
                                        {item.size}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Accordion> */}
    </Paper>
  );
};

export default ExternalInformation;
